import React from "react";
import { Tooltip } from "@mui/material";

export const IconWithToolTip = (props: any ) => {
    const { message, iconName, placement, handleClick } = props;
    return (
      <>
      <Tooltip title={message ? message : ""} placement={placement ? placement : "top"}>  
        <i className={iconName} onClick={handleClick}/>
       </Tooltip>
      </>
    );
};
